"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_web_components_1 = require("@nimles/react-web-components");

var StandardInput = function StandardInput(_a) {
  var field = _a.field,
      // { name, value, onChange, onBlur }
  _b = _a.form,
      touched = _b.touched,
      errors = _b.errors,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label = _a.label,
      required = _a.required,
      info = _a.info,
      props = __rest(_a, ["field", "form", "label", "required", "info"]);

  return react_1.default.createElement(react_1.default.Fragment, null, label && react_1.default.createElement(react_web_components_1.Label, {
    required: required,
    info: info
  }, label), react_1.default.createElement("div", null, react_1.default.createElement(react_web_components_1.Select, __assign({
    required: required
  }, field, props)), react_1.default.createElement("div", null, errors ? errors[field.name] : null)));
};

exports.SelectField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: StandardInput
  }));
};